export default "/_next/static/images/effect-left-2-d079c15791c4ead0acd352215883632a.svg";